<div class="py-4 py-sm-5 bg-marketing">
  <div class="footer d-flex flex-column gap-5 container">
    <div class="text-white d-flex flex-column flex-sm-row gap-3">
      @if(isAuthenticated){
      <div class="text-white d-flex flex-column gap-2 pe-5">
        <div class="text-white heavy support-title">
          GM Business&trade; Mastercard<sup>&reg;</sup>
        </div>
        <div class="">
          @for(route of footerRouting; track route){
          <div>
            <a
              class="gb-body3 text-white text-decoration-none support-body"
              [routerLink]="[route.route]"
              >{{route.page}}</a
            >
          </div>
          }
        </div>
      </div>
      }
      <div class="text-white d-flex flex-column gap-2">
        <div class="text-white heavy font-over support-title">
          Customer Support
        </div>
        <div class="">
          <div>
            <a
              class="text-white text-decoration-none support-body"
              target="_blank"
              href="https://cards.barclaycardus.com/banking/cards/faqs/gm/"
              >FAQs</a
            >
          </div>
          <div>
            <a
              class="text-white text-decoration-none support-body"
              target="_blank"
              href="https://www.gm.com/company/contact-us?evar25=GMCard_SignIn_Text_Contact-Us"
              >Contact Us</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-3">
      <div
        [innerHtml]="$safeNavigationMigration(footerContent?.title)"
        class="disclaimer-c"
      ></div>
      <ol
        class="d-flex flex-column gap-2 text-white disclaimer-c ps-2"
        type="1"
      >
        @for(disclaimer of disclaimers; track disclaimer){
        <li [innerHTML]="disclaimer"></li>
        }
      </ol>
      <div
        class="gb-body3 text-white disclaimer-c"
        [innerHtml]="$safeNavigationMigration(footerContent?.notice)"
      ></div>
    </div>
  </div>
</div>
